import { call } from "../helpers/axiosInterceptor";
import { AxiosError } from "axios";

export const getAdminProfile = async (token) => {
    try {
        const response = await call.get("admin/profile", {
            headers: {
                Authorization: "Bearer " + localStorage.getItem("refToken"),
            }
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching admin profile:", error);
        throw error;
    }
};

export const changeAdminPassword = async (
    token: string,
    currentPassword: string,
    newPassword: string,
    confirmPassword: string
) => {
    try {
        const response = await call.post(
            "admin/change-password",
            { currentPassword, newPassword, confirmPassword },
            {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("refToken"),
                    "Content-Type": "application/json",
                },
            }
        );
        return response.data;
    } catch (error) {
        console.error("Error in changePassword:", error);
        throw error;
    }
};

export const getAllAdmins = async () => {
    try {
        const response = await call.get("admin/all", {});  // ✅ Fix: Add empty object
        return response.data;
    } catch (error) {
        console.error("Error fetching all admins:", error);
        throw error;
    }
};


export const createAdmin = async (adminData: { name: string; email: string; password: string }) => {
    try {
        const response = await call.post(
            "admin/create",
            adminData,
            {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("refToken"),
                    "Content-Type": "application/json",
                },
            }
        );
        return response.data;
    } catch (error) {
        console.error("Error creating admin:", error);
        throw error;
    }
};

export const updateAdmin = async (adminId: string, updatedData: { name: string; email: string }) => {
    try {
        const response = await call.put(
            `admin/update/${adminId}`,
            updatedData,
            {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("refToken"),
                    "Content-Type": "application/json",
                },
            }
        );
        return response.data;
    } catch (error) {
        console.error("Error updating admin:", error);
        throw error;
    }
};

export const deleteAdmin = async (adminId: string) => {
    try {
        const response = await call.delete(`admin/delete/${adminId}`, {
            headers: {
                Authorization: "Bearer " + localStorage.getItem("refToken"),
            }
        });
        return response.data;
    } catch (error) {
        console.error("Error deleting admin:", error);
        throw error;
    }
};


export const forgotPassword = async (email: string) => {
    try {
        const response = await call.post(
            "auth/forgot-password",
            { email },
            {
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );
        return response.data;
    } catch (error) {
        console.error("Error in forgotPassword:", error);
        throw error;
    }
};

export const resetPassword = async (token, password) => {
    try {
        const response = await call.post(
            "auth/reset-password",
            { token, password },
            {
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );
        return response.data;
    } catch (error) {
        console.error("Error in resetPassword:", error);
        throw error;
    }
};





